import { z } from 'zod';

import { requiredArray, requiredString } from '@/shared/utils/validation';

export const projectSchema = z.object({
  name: requiredString(),
  projectId: requiredString(),
  objectVersion: z.number(),
});

export const addProjectInputSchema = z.object({
  projects: requiredArray(projectSchema),
});
